import { IMockProps, ErrorResponseCodeType } from '_core/types';
import {
  ENDPOINT_API_PATH,
  CODE_ERRORS,
} from '../Definitions/HeadlessDeliveryDef';

const autoGenerateSuccess = () => {
  const success: IMockProps = {
    doc: {
      code: 'Enviado com Sucesso',
      message: 'Enviado com Sucesso',
    },
    configRequest: {
      method: 'GET',
      path: ENDPOINT_API_PATH,
      params: {
        flatten: true,
        filter: `(friendlyUrlPath eq 'telefones_central')`,
      },
    },
    configResponse: {
      status: 200,
      data: {
        actions: {
          get: {
            method: 'GET',
            href:
              'https://api-cms-portal-uat4.smiles.com.br/o/headless-delivery/v1.0/sites/{siteId}/structured-contents',
          },
        },
        facets: [],
        items: [
          {
            actions: {
              'get-rendered-content': {
                method: 'GET',
                href:
                  'https://api-cms-portal-uat4.smiles.com.br/o/headless-delivery/v1.0/structured-contents/{structuredContentId}/rendered-content/{contentTemplateId}',
              },
              get: {
                method: 'GET',
                href:
                  'https://api-cms-portal-uat4.smiles.com.br/o/headless-delivery/v1.0/structured-contents/{structuredContentId}',
              },
            },
            availableLanguages: ['pt-BR'],
            contentFields: [
              {
                contentFieldValue: {
                  data: 'Telefones da Central Smiles',
                },
                dataType: 'string',
                inputControl: 'text',
                label: 'Título da Lista',
                name: 'headline',
                nestedContentFields: [],
                repeatable: false,
              },
              {
                contentFieldValue: {
                  data: '',
                },
                dataType: 'string',
                inputControl: 'textarea',
                label: 'Descrição ou Comentário',
                name: 'description',
                nestedContentFields: [],
                repeatable: false,
              },
              {
                contentFieldValue: {},
                dataType: '',
                label: 'Contato:',
                name: 'Contato',
                nestedContentFields: [
                  {
                    contentFieldValue: {
                      data: 'Smiles e Prata',
                    },
                    dataType: 'string',
                    inputControl: 'text',
                    label: 'Nome do contato',
                    name: 'contactName',
                    nestedContentFields: [],
                    repeatable: false,
                  },
                  {
                    contentFieldValue: {
                      data:
                        'Telefone: 0300 115 7001\nHorário de atendimento: 06h - 00h',
                    },
                    dataType: 'string',
                    inputControl: 'textarea',
                    label: 'Dados de contato',
                    name: 'contactData',
                    nestedContentFields: [],
                    repeatable: false,
                  },
                ],
                repeatable: true,
              },
              {
                contentFieldValue: {},
                dataType: '',
                label: 'Contato:',
                name: 'Contato',
                nestedContentFields: [
                  {
                    contentFieldValue: {
                      data: 'Diamante e Ouro',
                    },
                    dataType: 'string',
                    inputControl: 'text',
                    label: 'Nome do contato',
                    name: 'contactName',
                    nestedContentFields: [],
                    repeatable: false,
                  },
                  {
                    contentFieldValue: {
                      data:
                        'Telefone: 0300 115 7007\nHorário de atendimento: 24h',
                    },
                    dataType: 'string',
                    inputControl: 'textarea',
                    label: 'Dados de contato',
                    name: 'contactData',
                    nestedContentFields: [],
                    repeatable: false,
                  },
                ],
                repeatable: true,
              },
              {
                contentFieldValue: {},
                dataType: '',
                label: 'Contato:',
                name: 'Contato',
                nestedContentFields: [
                  {
                    contentFieldValue: {
                      data: 'Deficientes Auditivos',
                    },
                    dataType: 'string',
                    inputControl: 'text',
                    label: 'Nome do contato',
                    name: 'contactName',
                    nestedContentFields: [],
                    repeatable: false,
                  },
                  {
                    contentFieldValue: {
                      data:
                        'Telefone: 0300 709 0466\nHorário de atendimento: 24h',
                    },
                    dataType: 'string',
                    inputControl: 'textarea',
                    label: 'Dados de contato',
                    name: 'contactData',
                    nestedContentFields: [],
                    repeatable: false,
                  },
                ],
                repeatable: true,
              },
            ],
            contentStructureId: 45013,
            creator: {
              additionalName: '',
              contentType: 'UserAccount',
              familyName: 'Smiles',
              givenName: 'Administrador',
              id: 20130,
              name: 'Administrador Smiles',
            },
            customFields: [],
            dateCreated: '2020-12-09T12:40:09Z',
            dateModified: '2020-12-09T12:40:09Z',
            datePublished: '2020-12-09T12:35:00Z',
            description: '',
            friendlyUrlPath: 'telefones_central',
            id: 47604,
            key: '825748',
            keywords: [],
            numberOfComments: 0,
            relatedContents: [],
            renderedContents: [],
            siteId: 20124,
            subscribed: false,
            taxonomyCategoryBriefs: [],
            title: 'telefones_central',
            uuid: 'e1d306cf-c52f-927d-a6dc-bce224792c5f',
          },
        ],
        lastPage: 1,
        page: 1,
        pageSize: 20,
        totalCount: 1,
      },
    },
  };
  return success;
};

const autoGenerate = () => {
  const listOfErrorsMock: IMockProps[] = CODE_ERRORS.map(
    (error: ErrorResponseCodeType, index: number) => {
      const formatedError: IMockProps = {
        doc: {
          code: error.code,
          message: error.message,
        },
        configRequest: {
          method: 'GET',
          path: ENDPOINT_API_PATH,
          params: {
            flatten: true,
            filter: `(friendlyUrlPath eq ${index}-telefones_central)`,
          },
        },
        configResponse: {
          status: 452,
          data: {
            code: error.code,
            message: error.message,
          },
          headers: {},
        },
      };

      return formatedError;
    },
  );
  return listOfErrorsMock;
};

const autoGenerateResponseAutoCompleteTelCentral = autoGenerateSuccess();

const generatedSuccessMocks = [autoGenerateResponseAutoCompleteTelCentral];

const autoGenerateErrorsMock = () => {
  const errorPartner = autoGenerate();
  return [...errorPartner];
};

const errorsGenerated = autoGenerateErrorsMock();

const Mocks = [...generatedSuccessMocks, ...errorsGenerated];

export default Mocks;
